import { Component } from '@angular/core';

@Component({
  selector: 'app-tlm-edit-threat-employment-history',
  templateUrl: './employment-history.component.html'
})
export class EditThreatEmploymentHistoryComponent {}
